import Chart from "react-apexcharts";
import { formatMonthLabel, formatPercent } from "./fulfillment-kpi.helpers";
import { KPI_COLORS } from "./fulfillment-kpi.styles";

// Monthly shares in % with a target line. Uses react-apexcharts directly,
// because the shared BarChart wrapper has no annotations or tooltip hook.
const KpiBarChart = ({
  series,
  target,
  targetLabel,
  language,
  runningLabel,
  tooltipFor,
  colors,
  height = 280
}) => {
  const options = {
    // series colors for the legend; the bars use their own fillColor
    ...(colors ? { colors } : {}),
    // no chart.id: the page shows three charts, ApexCharts finds charts by id
    chart: { toolbar: { show: false } },
    plotOptions: { bar: { columnWidth: "55%" } },
    dataLabels: { enabled: false },
    legend: { show: series.length > 1, position: "top" },
    xaxis: {
      labels: {
        formatter: (month) => {
          const label = formatMonthLabel(month, language);
          const running = series[0]?.data.find((p) => p.x === month)?.running;
          return running ? `${label} (${runningLabel})` : label;
        }
      }
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: { formatter: (value) => `${Math.round(value)} %` }
    },
    annotations:
      target !== undefined
        ? {
            yaxis: [
              {
                y: target,
                borderColor: KPI_COLORS.targetLine,
                strokeDashArray: 4,
                label: {
                  text: targetLabel,
                  style: { color: "#fff", background: KPI_COLORS.targetLine }
                }
              }
            ]
          }
        : {},
    tooltip: {
      y: {
        formatter: (value, { dataPointIndex }) => {
          if (value === null || value === undefined) return "–";
          const extra = tooltipFor ? tooltipFor(dataPointIndex) : "";
          return `${formatPercent(value, language)}${extra ? ` · ${extra}` : ""}`;
        }
      }
    }
  };
  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={height}
      width="100%"
    />
  );
};

export default KpiBarChart;
